let timeout: NodeJS.Timeout | null = null;
let isInitialized: boolean = false;
const TIMEOUT_DURATION = 60 * 60 * 1000;

const logout = (): void => {
  localStorage.clear();
  sessionStorage.clear();
  document.cookie.split(";").forEach((cookie: string) => {
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = `${name}=;max-age=0;path=/`;
  });
  window.location.href = "/auth";
};

const resetTimeout = (): void => {
  if (timeout) {
    clearTimeout(timeout);
  }
  timeout = setTimeout(() => {
    logout();
  }, TIMEOUT_DURATION);
};

const setupEventListeners = (): void => {
  const events: string[] = [
    "mousedown",
    "mousemove",
    "keypress",
    "scroll",
    "touchstart",
    "click",
    "keydown",
    "focus",
  ];

  events.forEach((event: string) => {
    document.addEventListener(event, resetTimeout, true);
  });

  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      resetTimeout();
    }
  });
};

const init = (): void => {
  if (isInitialized) return;
  setupEventListeners();
  resetTimeout();
  isInitialized = true;

};

const destroy = (): void => {
  if (timeout) {
    clearTimeout(timeout);
  }

  const events: string[] = [
    "mousedown",
    "mousemove",
    "keypress",
    "scroll",
    "touchstart",
    "click",
    "keydown",
    "focus",
  ];

  events.forEach((event: string) => {
    document.removeEventListener(event, resetTimeout, true);
  });

  document.removeEventListener("visibilitychange", resetTimeout);
  isInitialized = false;
};

const autoLogout = {
  init,
  logout,
  resetTimeout,
  destroy,
};

export default autoLogout;
